import React from 'react';
import { feedback, elements } from '@ecosystem/newron-design-system';
import { Entity } from '../../types';

type Props = {
  onItemClick: (entity: Entity) => void;
  options?: (Entity | string)[];
  value?: Entity[];
  isMulti?: boolean;
};
function SelectionList({ onItemClick, options, isMulti = false, value = [] }: Props) {
  const { DotsLoader } = feedback;

  if (!options) {
    return (
      <div className="h-40 flex flex-column items-center justify-center">
        <DotsLoader compact />
        <span className="text-xs text-inactive mt-3">Loading options...</span>
      </div>
    );
  }

  return (
    <div className="overflow-y-auto overscroll-contain" style={{ maxHeight: '380px' }}>
      {options.map(opt =>
        typeof opt === 'string' ? (
          <span className="block text-sm text-lighter px-2 py-1 bg-medium font-bold" key={opt}>
            {opt}
          </span>
        ) : (
          <MenuItem
            key={opt.value}
            onClick={() => onItemClick(opt)}
            canBeUnselected={isMulti}
            entity={opt}
            value={value}
          />
        )
      )}
    </div>
  );
}

type ItemProps = {
  entity: Entity;
  canBeUnselected: boolean;
  value?: Entity[];
  onClick: () => void;
};
function MenuItem({ entity, canBeUnselected, onClick, value = [] }: ItemProps) {
  const isActive = value.find(ent => ent.value === entity.value) !== undefined;

  const { Icon } = elements;

  if (isActive && !canBeUnselected) {
    return (
      <div className="py-2 px-4 flex gap-x-2 items-center bg-light">
        <div className="flex-grow">
          <span className="nowrap">{entity.label}</span>
        </div>
        <Icon>
          <Icon.icons.Check />
        </Icon>
      </div>
    );
  }

  return (
    <button
      onClick={onClick}
      className="w-full px-4 flex items-center py-2 text-left transition-colors hover:bg-brand-light"
    >
      <span className="flex-grow">
        <span className="nowrap">{entity.label}</span>
      </span>
      <span className={`${isActive ? 'visible' : 'hidden'}`}>
        <Icon>
          <Icon.icons.Check />
        </Icon>
      </span>
    </button>
  );
}

export { SelectionList };
